import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';

import './Resources/dashboard.css';
import axios from './../axios.js';
import Navbar from './Supportingfiles/navbar';
import Sidebar from './Supportingfiles/sidebar';
//import Create_loanrequests from './create_newaccounts';



function Employee_day_cash(){

 //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const logname=sessionStorage.getItem("logName00");
 const editId=sessionStorage.getItem("EditId00");
 const branchId=sessionStorage.getItem("branchId00");

  //SETTING DATA VARIABLES
  const[date,setdate]=useState(sessionStorage.getItem("CDate00"));const updatedate = (event) => { setdate(event.target.value);}; const[date_er,setdate_er]=useState();
  const[transaction,settransaction]=useState();const updatetransaction = (event) => { settransaction(event.target.value);}; const[transaction_er,settransaction_er]=useState();
  const[particular,setparticular]=useState();const updateparticular = (event) => { setparticular(event.target.value);}; const[particular_er,setparticular_er]=useState();
  const[amount,setamount]=useState(sessionStorage.getItem("CAmount00"));const updateamount = (event) => { setamount(event.target.value);}; const[amount_er,setamount_er]=useState();

  //currency counts
  const[c2000_in,setc2000_in]=useState(0);const updatec2000_in = (event) => { setc2000_in(event.target.value); /* handlecurrency(); */ }; const[c2000_in_er,setc2000_in_er]=useState();
  const[c500_in,setc500_in]=useState(0);const updatec500_in = (event) => { setc500_in(event.target.value); /* handlecurrency(); */ }; const[c500_in_er,setc500_in_er]=useState();
  const[c200_in,setc200_in]=useState(0);const updatec200_in = (event) => { setc200_in(event.target.value); /* handlecurrency(); */ }; const[c200_in_er,setc200_in_er]=useState();
  const[c100_in,setc100_in]=useState(0);const updatec100_in = (event) => { setc100_in(event.target.value); /* handlecurrency(); */ }; const[c100_in_er,setc100_in_er]=useState();
  const[c50_in,setc50_in]=useState(0);const updatec50_in = (event) => { setc50_in(event.target.value); /* handlecurrency(); */ }; const[c50_in_er,setc50_in_er]=useState();
  const[c20_in,setc20_in]=useState(0);const updatec20_in = (event) => { setc20_in(event.target.value);  /* handlecurrency(); */ }; const[c20_in_er,setc20_in_er]=useState();
  const[c10_in,setc10_in]=useState(0);const updatec10_in = (event) => { setc10_in(event.target.value); /* handlecurrency(); */ }; const[c10_in_er,setc10_in_er]=useState();
  const[c5_in,setc5_in]=useState(0);const updatec5_in = (event) => { setc5_in(event.target.value); /* handlecurrency(); */ }; const[c5_in_er,setc5_in_er]=useState();
  const[c2_in,setc2_in]=useState(0);const updatec2_in = (event) => { setc2_in(event.target.value); /* handlecurrency(); */ }; const[c2_in_er,setc2_in_er]=useState();
  const[c1_in,setc1_in]=useState(0);const updatec1_in = (event) => { setc1_in(event.target.value); /* handlecurrency(); */ }; const[c1_in_er,setc1_in_er]=useState();
  const[c2000_out,setc2000_out]=useState(0);const updatec2000_out = (event) => { setc2000_out(event.target.value); /* handlecurrency(); */ }; const[c2000_out_er,setc2000_out_er]=useState();
  const[c500_out,setc500_out]=useState(0);const updatec500_out = (event) => { setc500_out(event.target.value); /* handlecurrency(); */ }; const[c500_out_er,setc500_out_er]=useState();
  const[c200_out,setc200_out]=useState(0);const updatec200_out = (event) => { setc200_out(event.target.value); /* handlecurrency(); */ }; const[c200_out_er,setc200_out_er]=useState();
  const[c100_out,setc100_out]=useState(0);const updatec100_out = (event) => { setc100_out(event.target.value); /* handlecurrency(); */ }; const[c100_out_er,setc100_out_er]=useState();
  const[c50_out,setc50_out]=useState(0);const updatec50_out = (event) => { setc50_out(event.target.value); /* handlecurrency(); */ }; const[c50_out_er,setc50_out_er]=useState();
  const[c20_out,setc20_out]=useState(0);const updatec20_out = (event) => { setc20_out(event.target.value); /* handlecurrency(); */ }; const[c20_out_er,setc20_out_er]=useState();
  const[c10_out,setc10_out]=useState(0);const updatec10_out = (event) => { setc10_out(event.target.value); /* handlecurrency(); */ }; const[c10_out_er,setc10_out_er]=useState();
  const[c5_out,setc5_out]=useState(0);const updatec5_out = (event) => { setc5_out(event.target.value); /* handlecurrency(); */ }; const[c5_out_er,setc5_out_er]=useState();
  const[c2_out,setc2_out]=useState(0);const updatec2_out = (event) => { setc2_out(event.target.value); /* handlecurrency(); */ }; const[c2_out_er,setc2_out_er]=useState();
  const[c1_out,setc1_out]=useState(0);const updatec1_out = (event) => { setc1_out(event.target.value); /* handlecurrency(); */ }; const[c1_out_er,setc1_out_er]=useState();

  const[ccount_in,setccount_in]=useState(0);const updateccount_in = (event) => { setccount_in(event.target.value);}; const[ccount_in_er,setccount_in_er]=useState();
  const[ccount_out,setccount_out]=useState(0);const updateccount_out = (event) => { setccount_out(event.target.value);}; const[ccount_out_er,setccount_out_er]=useState();
  const[ctotal_in,setctotal_in]=useState(0);const updatectotal_in = (event) => { setctotal_in(event.target.value);}; const[ctotal_in_er,setctotal_in_er]=useState();
  const[ctotal_out,setctotal_out]=useState(0);const updatectotal_out = (event) => { setctotal_out(event.target.value);}; const[ctotal_out_er,setctotal_out_er]=useState();
  const[camount,setcamount]=useState(0);const updatecamount = (event) => { setcamount(event.target.value);}; const[camount_er,setcamount_er]=useState();

  
 //ERROR VARIABLES 
 const[error_msg,seterror_msg]=useState();

 //image upload
 //File Upload
 const [selectedFile, setSelectedFile] = React.useState(null);
 const handleFileChange = (event) => {  const file = event.target.files[0];  setSelectedFile(file); };
 const[attachment_link_er,setattachment_link_er]=useState();

 useEffect(() => {
  handlecurrency();
}, [
  c2000_in, c500_in, c200_in, c100_in, c50_in, c20_in, c10_in, c5_in, c2_in, c1_in,
  c2000_out, c500_out, c200_out, c100_out, c50_out, c20_out, c10_out, c5_out, c2_out, c1_out
]);


 //handle currency function
 function handlecurrency(){

  //currency count
  const $c2000_in = parseInt(c2000_in) || 0;
  const $c500_in = parseInt(c500_in) || 0;
  const $c200_in = parseInt(c200_in) || 0;
  const $c100_in = parseInt(c100_in) || 0;
  const $c50_in = parseInt(c50_in) || 0;
  const $c20_in = parseInt(c20_in) || 0;
  const $c10_in = parseInt(c10_in) || 0;
  const $c5_in = parseInt(c5_in) || 0;
  const $c2_in = parseInt(c2_in) || 0;
  const $c1_in = parseInt(c1_in) || 0;
  const $c2000_out = parseInt(c2000_out) || 0;
  const $c500_out = parseInt(c500_out) || 0;
  const $c200_out = parseInt(c200_out) || 0;
  const $c100_out = parseInt(c100_out) || 0;
  const $c50_out = parseInt(c50_out) || 0;
  const $c20_out = parseInt(c20_out) || 0;
  const $c10_out = parseInt(c10_out) || 0;
  const $c5_out = parseInt(c5_out) || 0;
  const $c2_out = parseInt(c2_out) || 0;
  const $c1_out = parseInt(c1_out) || 0;

/*const $c2000_in = parseInt(document.getElementById("c2000_in").value);
const $c500_in = parseInt(document.getElementById("c500_in").value);
const $c200_in = parseInt(document.getElementById("c200_in").value);
const $c100_in =  parseInt(document.getElementById("c100_in").value);
const $c50_in =  parseInt(document.getElementById("c50_in").value);
const $c20_in =  parseInt(document.getElementById("c2000_in").value);
const $c10_in =  parseInt(document.getElementById("c10_in").value);
const $c5_in =  parseInt(document.getElementById("c5_in").value);
const $c2_in =  parseInt(document.getElementById("c2_in").value);
const $c1_in =  parseInt(document.getElementById("c1_in").value);
const $c2000_out =  parseInt(document.getElementById("c2000_out").value);
const $c500_out =  parseInt(document.getElementById("c500_out").value);
const $c200_out =  parseInt(document.getElementById("c200_out").value);
const $c100_out =  parseInt(document.getElementById("c100_out").value);
const $c50_out =  parseInt(document.getElementById("c50_out").value);
const $c20_out =  parseInt(document.getElementById("c2000_out").value);
const $c10_out =  parseInt(document.getElementById("c10_out").value);
const $c5_out =  parseInt(document.getElementById("c5_out").value);
const $c2_out =  parseInt(document.getElementById("c2_out").value);
const $c1_out =  parseInt(document.getElementById("c1_out").value);

const $ccount_in = $c2000_in+$c500_in+$c200_in+$c100_in+$c50_in+$c20_in+$c10_in+$c5_in+$c2_in+$c1_in;
const $ccount_out = $c2000_out+$c500_out+$c200_out+$c100_out+$c50_out+$c20_out+$c10_out+$c5_out+$c2_out+$c1_out;
const $ctotal_in = ($c2000_in*2000)+($c500_in*500)+($c200_in*200 )+($c100_in*100 )+($c50_in*50)+($c20_in*20)+($c10_in*10)+($c5_in*5)+($c2_in*2)+($c1_in*1);
const $ctotal_out = ($c2000_out*2000)+($c500_out*500)+($c200_out*200 )+($c100_out*100 )+($c50_out*50)+($c20_out*20)+($c10_out*10)+($c5_out*5)+($c2_out*2)+($c1_out*1);
const $camount = $ctotal_in - $ctotal_out; */

  const $ccount_in = $c2000_in + $c500_in + $c200_in + $c100_in + $c50_in + $c20_in + $c10_in + $c5_in + $c2_in + $c1_in;
  const $ccount_out = $c2000_out + $c500_out + $c200_out + $c100_out + $c50_out + $c20_out + $c10_out + $c5_out + $c2_out + $c1_out;

  const $ctotal_in = ($c2000_in * 2000) + ($c500_in * 500) + ($c200_in * 200) + ($c100_in * 100) + ($c50_in * 50) + ($c20_in * 20) + ($c10_in * 10) + ($c5_in * 5) + ($c2_in * 2) + ($c1_in * 1);
  const $ctotal_out = ($c2000_out * 2000) + ($c500_out * 500) + ($c200_out * 200) + ($c100_out * 100) + ($c50_out * 50) + ($c20_out * 20) + ($c10_out * 10) + ($c5_out * 5) + ($c2_out * 2) + ($c1_out * 1);

  const $camount = $ctotal_in - $ctotal_out;

setccount_in($ccount_in);
setccount_out($ccount_out);
setctotal_in($ctotal_in);
setctotal_out($ctotal_out);
setcamount($camount);


 }
 
 
/***************** CREATE CASH FUNCTION START  ******************/
function create_cash(){

  
  //Checking if user loggedin
  if(((logstatus!=null)||(logstatus!=""))&&((logid!=null)||(logid!=""))&&((token!=null)||(token!=" "))&&((logname!=null)||(logname!=" "))){


    //Setting Error Variables
    seterror_msg(" ");
    setc2000_in_er(" "); setc500_in_er(" "); setc200_in_er(" "); setc100_in_er(" "); setc50_in_er(" "); setc20_in_er(" "); setc10_in_er(" "); setc5_in_er(" "); setc2_in_er(" "); setc1_in_er(" ");
    setc2000_out_er(" "); setc500_out_er(" "); setc200_out_er(" "); setc100_out_er(" "); setc50_out_er(" "); setc20_out_er(" "); setc10_out_er(" "); setc5_out_er(" "); setc2_out_er(" "); setc1_in_er(" ");
    setccount_in_er(" "); setccount_out_er(" "); setctotal_in_er(" "); setctotal_out_er(" "); setcamount_er(" ");
    
//Fetching Form Data
let noerror = 0;
//currency count
const $c2000_in = document.getElementById("c2000_in").value;
const $c500_in = document.getElementById("c500_in").value;
const $c200_in = document.getElementById("c200_in").value;
const $c100_in = document.getElementById("c100_in").value;
const $c50_in = document.getElementById("c50_in").value;
const $c20_in = document.getElementById("c20_in").value;
const $c10_in = document.getElementById("c10_in").value;
const $c5_in = document.getElementById("c5_in").value;
const $c2_in = document.getElementById("c2_in").value;
const $c1_in = document.getElementById("c1_in").value;
const $c2000_out = document.getElementById("c2000_out").value;
const $c500_out = document.getElementById("c500_out").value;
const $c200_out = document.getElementById("c200_out").value;
const $c100_out = document.getElementById("c100_out").value;
const $c50_out = document.getElementById("c50_out").value;
const $c20_out = document.getElementById("c20_out").value;
const $c10_out = document.getElementById("c10_out").value;
const $c5_out = document.getElementById("c5_out").value;
const $c2_out = document.getElementById("c2_out").value;
const $c1_out = document.getElementById("c1_out").value;



if(amount != camount){
  seterror_msg("Currency Amount Do Not Match the Amount !"); return;
}


//No primary errors
if(noerror==0){


  //Sending Data through axios
  axios.post("crm-employee_day_summary_completion", { 
  Log_id:logid,
  Token:token,

  //currency count
  C2000_in:$c2000_in,
  C500_in:$c500_in,
  C200_in:$c200_in,
  C100_in:$c100_in,
  C50_in:$c50_in,
  C20_in:$c20_in,
  C10_in:$c10_in,
  C5_in:$c5_in,
  C2_in:$c2_in,
  C1_in:$c1_in,
  C2000_out:$c2000_out,
  C500_out:$c500_out,
  C200_out:$c200_out,
  C100_out:$c100_out,
  C50_out:$c50_out,
  C20_out:$c20_out,
  C10_out:$c10_out,
  C5_out:$c5_out,
  C2_out:$c2_out,
  C1_out:$c1_out,
  Edit_id:editId,
  Branch_id:branchId,

    }
    )
  
  .then((response) => {


  //Validation Errors
  if(response.data.validatorerror){
  setdate_er(response.data.validatorerror.Date);
  settransaction_er(response.data.validatorerror.Transaction);
  setparticular_er(response.data.validatorerror.Particular);
  setamount_er(response.data.validatorerror.Amount);
  setattachment_link_er(response.data.validatorerror.File_attachment);

  setc2000_in_er(response.data.validatorerror.C2000_in);
  setc500_in_er(response.data.validatorerror.C500_in);
  setc200_in_er(response.data.validatorerror.C200_in);
  setc100_in_er(response.data.validatorerror.C100_in);
  setc50_in_er(response.data.validatorerror.C50_in);
  setc20_in_er(response.data.validatorerror.C20_in);
  setc10_in_er(response.data.validatorerror.C10_in);
  setc5_in_er(response.data.validatorerror.C5_in);
  setc2_in_er(response.data.validatorerror.C2_in);
  setc1_in_er(response.data.validatorerror.C1_in);
  setc2000_out_er(response.data.validatorerror.C2000_out);
  setc500_out_er(response.data.validatorerror.C500_out);
  setc200_out_er(response.data.validatorerror.C200_out);
  setc100_out_er(response.data.validatorerror.C100_out);
  setc50_out_er(response.data.validatorerror.C50_out);
  setc20_out_er(response.data.validatorerror.C20_out);
  setc10_out_er(response.data.validatorerror.C10_out);
  setc5_out_er(response.data.validatorerror.C5_out);
  setc2_out_er(response.data.validatorerror.C2_out);
  setc1_out_er(response.data.validatorerror.C1_out);

  seterror_msg("Cannot Add Transaction !");
  
  
  }
  //Invalid Entries
  if(response.data.error==102){ 

  setdate_er(response.data.date_er);
  settransaction_er(response.data.transaction_er);
  setparticular_er(response.data.particular_er);
  setamount_er(response.data.amount_er);

  setc2000_in_er(response.data.c2000_in_er);
  setc500_in_er(response.data.c500_in_er);
  setc200_in_er(response.data.c200_in_er);
  setc100_in_er(response.data.c100_in_er);
  setc50_in_er(response.data.c50_in_er);
  setc20_in_er(response.data.c20_in_er);
  setc10_in_er(response.data.c10_in_er);
  setc5_in_er(response.data.c5_in_er);
  setc2_in_er(response.data.c2_in_er);
  setc1_in_er(response.data.c1_in_er);
  setc2000_out_er(response.data.c2000_out_er);
  setc500_out_er(response.data.c500_out_er);
  setc200_out_er(response.data.c200_out_er);
  setc100_out_er(response.data.c100_out_er);
  setc50_out_er(response.data.c50_out_er);
  setc20_out_er(response.data.c20_out_er);
  setc10_out_er(response.data.c10_out_er);
  setc5_out_er(response.data.c5_out_er);
  setc2_out_er(response.data.c2_out_er);
  setc1_out_er(response.data.c1_out_er);

  seterror_msg("Cannot Add Transaction !");
  
  
  }
  
  //Branch Name or Branch Code Already Exists
  if(response.data.error==103){  seterror_msg(response.data.error_msg); return; }
  
  //Success
  if(response.data.successvar==1){ document.getElementById("success-card").style.display="block"; }

  //failure
  if(response.data.successvar==6){ seterror_msg("Cannot Add Transaction !"); }

  //Session Expired
  if(response.data.successvar==100){ seterror_msg("Session Expired !");  }


  }    );
  
  }
  

  }
  //User not Logedin
 else{
 
 //Remove Session Variables and redirect to login
 sessionStorage.removeItem("logStatus00");
 sessionStorage.removeItem("logId00");
 sessionStorage.removeItem("logToken00");
 sessionStorage.removeItem("logName00");
 
 window.location.replace("/");
 
 
 }    

}

/***************** CREATE TRANSACTION FUNCTION END  ******************/


return(
    <>

<html lang="en">
  <head>
    {/*} Required meta tags */}
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    <title>Pragati Prathmik Sakh Sahkari Samiti Maryadit |  Employee Dashboard</title>
    {/*} plugins:css */}
    <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
    {/*} endinject */}
    {/*} Plugin css for this page */}
    <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
    <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
    {/*} End plugin css for this page */}
    {/*} inject:css */}
    {/*} endinject */}
    {/*} Layout styles */}
    <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
    {/*} End layout styles */}
    <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
  </head>
  <body>
    <div className="container-scroller">

   {/*}   <Sidebar /> */}
    <div className="container-fluid page-body-wrapper">


       <Navbar />
        {/*} partial */}
        <div className="main-panel">

        

          <div className="content-wrapper pb-0">

          

                 {/*  SUCCESS CARD START */}
                 <div class="d-flex justify-content-center">
               <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="success-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title  text-success">Currency Updated Successfully !!!</h4>
                  
                    <blockquote class="blockquote">
                      <p class="mb-0"> Click the following button to continue.</p>
                      <a href="/employee-dashboard-daysummary"><button class="mt-3 btn btn-outline-success">Continue</button></a>
                    </blockquote>
                  </div>
              
                </div>
              </div>
              </div>
              {/*  SUCCESS CARD END */}


          <div className="page-header flex-wrap">
          <div className="header-left">
           <button style={{marginTop:"2rem",marginLeft:"2rem"}} class="btn btn-outline-info" onClick={()=>{ window.location.replace("/employee-dashboard-daysummary")}}>  Back </button>
            </div>
              <div className="header-right d-flex flex-wrap mt-2 mt-sm-0">
                <div className="d-flex align-items-center">
                  <a href="#">
                    <p className="m-0 pe-3">EMPLOYEE PANEL</p>
                  </a>
                  <a className="ps-3 me-4" href="#">
                    <p className="m-0">CURRENCY MANAGEMENT</p>
                  </a>
                </div>
          {/*}     <button type="button" className="btn btn-primary mt-2 mt-sm-0 btn-icon-text"  onClick={()=>{ 
               const createForm = document.getElementById('create-form');
               const currentDisplay = createForm.style.display;
               createForm.style.display = currentDisplay === 'none' ? 'block' : 'none'; }}>
                  <i className="mdi mdi-plus-circle"></i>New Loan Request</button>  */}
              </div>
            </div>


                <div class="card">
              
                  <div class="card-body" style={{textAlign:"left"}}>
                    <h4 class="card-title">Add Currencies</h4>
                    <div class="form-sample">
                      <p class="card-description">manage currency</p>
                      <code>{error_msg}</code>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Date</label>
                            <div class="col-sm-9">
                              <input type="date" class="form-control" id="date" value={date} onChange={updatedate} />
                              <code>{date_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Amount</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="5000.00" id="amount" value={amount} onChange={updateamount} />
                              <code>{amount_er}</code>
                            </div>
                          </div>
                        </div>   
                        </div>
                         
                      <h3 style={{textAlign:"left", marginTop:"2rem"}}>Currency/ Denomination</h3>
                        {/* CURRENCY ENTRY TABLE START */}
                        <div class="row">
                          <h6  style={{textAlign:"left", marginTop:"2rem"}}>Currency Entry</h6>
                          <table class="table table-bordered">
                            <thead>
                              <th>2000</th>
                              <th>500</th>
                              <th>200</th>
                              <th>100</th>
                              <th>50</th>
                              <th>20</th>
                              <th>10</th>
                              <th>5</th>
                              <th>2</th>
                              <th>1</th>
                              <th>Total</th>
                            </thead>
                            <tbody>
                              <td><input type="text" class="form-control" placeholder="5" id="c2000_in" value={c2000_in} onChange={updatec2000_in} />
                              <code>{c2000_in_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="3" id="c500_in" value={c500_in} onChange={updatec500_in} />
                              <code>{c500_in_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="2" id="c200_in" value={c200_in} onChange={updatec200_in} />
                              <code>{c200_in_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="2" id="c100_in" value={c100_in} onChange={updatec100_in} />
                              <code>{c100_in_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="1" id="c50_in" value={c50_in} onChange={updatec50_in} />
                              <code>{c50_in_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="3" id="c20_in" value={c20_in} onChange={updatec20_in} />
                              <code>{c20_in_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="3" id="c10_in" value={c10_in} onChange={updatec10_in} />
                              <code>{c10_in_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="5" id="c5_in" value={c5_in} onChange={updatec5_in} />
                              <code>{c5_in_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="3" id="c2_in" value={c2_in} onChange={updatec2_in} />
                              <code>{c2_in_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="3" id="c1_in" value={c1_in} onChange={updatec1_in} />
                              <code>{c1_in_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="30" id="ccount_in" value={ccount_in} onChange={updateccount_in} />
                              <code>{ccount_in_er}</code></td>
                            </tbody>
                          </table>
                        </div>
                        {/* CURRENCY ENTRY TABLE END */}
                        {/* CURRENCY RETURN TABLE START */}
                          <div class="row">
                          <h6  style={{textAlign:"left", marginTop:"2rem"}}>Change Return</h6>
                          <table class="table table-bordered">
                            <thead>
                              <th>2000</th>
                              <th>500</th>
                              <th>200</th>
                              <th>100</th>
                              <th>50</th>
                              <th>20</th>
                              <th>10</th>
                              <th>5</th>
                              <th>2</th>
                              <th>1</th>
                              <th>Total</th>
                            </thead>
                            <tbody>
                              <td><input type="text" class="form-control" placeholder="5" id="c2000_out" value={c2000_out} onChange={updatec2000_out} />
                              <code>{c2000_out_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="3" id="c500_out" value={c500_out} onChange={updatec500_out} />
                              <code>{c500_out_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="2" id="c200_out" value={c200_out} onChange={updatec200_out} />
                              <code>{c200_out_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="2" id="c100_out" value={c100_out} onChange={updatec100_out} />
                              <code>{c100_out_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="1" id="c50_out" value={c50_out} onChange={updatec50_out} />
                              <code>{c50_out_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="3" id="c20_out" value={c20_out} onChange={updatec20_out} />
                              <code>{c20_out_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="3" id="c10_out" value={c10_out} onChange={updatec10_out} />
                              <code>{c10_out_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="5" id="c5_out" value={c5_out} onChange={updatec5_out} />
                              <code>{c5_out_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="3" id="c2_out" value={c2_out} onChange={updatec2_out} />
                              <code>{c2_out_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="3" id="c1_out" value={c1_out} onChange={updatec1_out} />
                              <code>{c1_out_er}</code></td>
                              <td><input type="text" class="form-control" placeholder="30" id="ccount_out" value={ccount_out} onChange={updateccount_out} />
                              <code>{ccount_out_er}</code></td>
                            </tbody>
                          </table>
                        </div>
                        {/* CURRENCY RETURN TABLE END */}

                        {/* CURRENCY TOTAL START */}
                       <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Currency Entry Count</label>
                            <br/><p>{ccount_in}</p>
                          </div>
                        </div>
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Currency Change Count</label>
                            <br/><p>{ccount_out}</p>
                          </div>
                        </div> 
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Currency Entry Count</label>
                            <br/><p>{ccount_in}</p>
                          </div>
                        </div>  
                         <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Amount Recieved</label>
                            <br/><p>{ctotal_in}</p>
                          </div>
                        </div> 
                          <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Amount Returned</label>
                            <br/><p>{ctotal_out}</p>
                          </div>
                        </div> 
                     
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Net Amount</label>
                            <br/><p>{camount}</p>
                          </div>
                        </div> 
                        </div>
                        {/* CURRENCY TOTAL END */}
                      
                        <button class="btn btn-lg btn-success mt-2" style={{fontWeight:"bold"}} onClick={create_cash}>Submit</button>
                      
                       
    
                     
                   
                    </div>
                  </div>
                </div>

                </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
       {/*}   <footer className="footer">
            <div className="d-sm-flex justify-content-center justify-content-sm-between">
              <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i className="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
    </>

);
}
//}

export default Employee_day_cash;